exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NotifiableActions_checkbox_1xHl {\n  margin: 15px 0\n}\n\n.NotifiableActions_checkbox_1xHl:first-child {\n  margin-top: 0;\n}\n\n.NotifiableActions_checkbox_1xHl:last-child {\n  margin-bottom: 0;\n}\n\n.NotifiableActions_checkbox_1xHl > span {\n  top: 2px;\n}\n\n.NotifiableActions_actions_3hDK {\n  margin-top: 30px;\n}\n\n.NotifiableActions_actionsDivider_2GHr {\n  margin: 0 15px;\n}\n", ""]);

// exports
exports.locals = {
	"checkbox": "NotifiableActions_checkbox_1xHl",
	"actions": "NotifiableActions_actions_3hDK",
	"actionsDivider": "NotifiableActions_actionsDivider_2GHr"
};